export const chat3_18 = [
	{
		"user": "leckonator",
		"message": "boah spritz gleich ab hier ihr seid der HAMMER",
		"time": "00:02"
	},
	{
		"user": "{f_model1}",
		"message": "ja Süßer, das mache ich doch gerne für dich. Alles was du willst!",
		"time": "00:05"
	},
	{
		"user": "sextiger",
		"message": "bessa als porno!",
		"time": "00:09"
	},
	{
		"user": "{f_model2}",
		"message": "ihr wollt doch bestimmt sowas sehen oder Jungs? ;-)  {muschi_pic}",
		"time": "00:15"
	},
	{
		"user": "sweetman22",
		"message": "@{f_model2}: jaaaa!!! Zeig mehr von dir!",
		"time": "00:20"
	},
	{
		"user": "meisterstecher69",
		"message": "steh mehr auf Ärsche",
		"time": "00:25"
	},
	{
		"user": "meisterstecher69",
		"message": "in welchen darf ich meinen harten Lümmel denn mal reinstecken?? ;-)",
		"time": "00:31"
	},
	{
		"user": "{m_model1}",
		"message": "Suche Jungs hier. Noch jemand? Oder bin ich hier falsch?",
		"time": "00:37"
	},
	{
		"user": "{f_model3}",
		"message": "{ass_pic}",
		"time": "00:44"
	},
	{
		"user": "{f_model4}",
		"message": "{video:613006_web}",
		"time": "00:49"
	},
	{
		"user": "{f_model5}",
		"message": "Hallöchen! Bin {f_model5}. Jemand Lust zu chatten? {video:627312_web}",
		"time": "00:56"
	},
	{
		"user": "{m_model2}",
		"message": "@{m_model1}: also dich würde ich nicht von der Bettkante schubsen ;-) Lust mit mir zu cammen?",
		"time": "01:02"
	},
	{
		"user": "meisterstecher69",
		"message": "wow gleich soviele im Angebot *grins* heiße Geschosse! Kann man euch auch beide haben? ;-)",
		"time": "01:10"
	},
	{
		"user": "{m_model3}",
		"message": "@{m_model1}: Bei mir bist du genau richtig :-D {ass_pic}",
		"time": "01:15"
	},
	{
		"user": "geiler_tom",
		"message": "@{f_model5}: hey babe kümmer mich schon um dich vergess den rest",
		"time": "01:22"
	},
	{
		"user": "{f_model2}",
		"message": "@sweetman22: meine Boobys? ;-) ich kann sie gerne mal für dich auspacken ;-) {video:627307_web}",
		"time": "01:30"
	},
	{
		"user": "{f_model3}",
		"message": "och, also ich verwöhn auch gerne mal zu dritt *gg* {video:627551_web}",
		"time": "01:37"
	},
	{
		"user": "{f_model5}",
		"message": "das Angebot nehme ich an geiler_tom ;-) Vor meiner cam sind wir ganz für uns alleine :-P kommst du?  {profile_link}",
		"time": "01:43"
	},
	{
		"user": "{f_model4}",
		"message": "zu zweit können wir uns viel besser um dich kümmern Süßer. Lehn dich zurück!",
		"time": "01:55"
	},
	{
		"user": "{f_model4}",
		"message": "sag uns nur was du magst",
		"time": "01:58"
	},
	{
		"user": "sweetman22",
		"message": "@{f_model2}: extrem geile Hupen!! Will den Rest kenennlernen wo kann ich dich sehen?",
		"time": "02:05"
	},
	{
		"user": "{f_model6}",
		"message": "Huhuu",
		"time": "02:11"
	},
	{
		"user": "{f_model6}",
		"message": "Jemand hier, der auf sowas steht? {hard_pic}",
		"time": "02:15"
	},
	{
		"user": "{f_model2}",
		"message": "Über mein Profil kommst du auf meine Webcam da zeig ich dir alles was du sehen willst ;-) {profile_link}",
		"time": "02:24"
	},
	{
		"user": "horny_john",
		"message": "@{f_model6}: :-o :-o :-o wie hot ist das denn bitte???",
		"time": "02:31"
	},
	{
		"user": "horny_john",
		"message": "@{f_model6}: zeigst du sowas auch vor der Cam?",
		"time": "02:37"
	},
	{
		"user": "sex_machine",
		"message": "Heyho! Kann man hier ficken??",
		"time": "02:45"
	},
	{
		"user": "{f_model6}",
		"message": "aber klar, vor der Cam kenne ich keine tabus :-D Du bestimmst!",
		"time": "02:53"
	},
	{
		"user": "{f_model1}",
		"message": "{video:621103_web}",
		"time": "02:56"
	}
]
